import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

const BASE = "/api/v1/physicians";

export const listPhysicians = () => apiGet(BASE).then((d) => d.physicians || []);
export const getPhysician = (id) => apiGet(`${BASE}/${id}`);
export const createPhysician = (data) => apiPost(BASE, data);
export const updatePhysician = (id, data) => apiPut(`${BASE}/${id}`, data);
export const deletePhysician = (id) => apiDelete(`${BASE}/${id}`);
export const matchPhysicians = (referral) => apiPost(`${BASE}/match`, referral);
